<template>
  <v-list>
    <v-radio-group v-model="value">
      <v-list-tile v-for="(item) in items" :key="item.id">
        <v-list-tile-action>
          <pos-checkbox 
            v-if="!radio"
            @input="update($event, item)" 
            :value="value && value.indexOf(item.id ? item.id : item) != -1" />
          <v-radio
            v-else
            @click="update($event, item)" 
            class="v-radio-group-custom"
            :value="item.id" 
            :color="'primary'"/>
        </v-list-tile-action>
        <v-list-tile-content @click="">
          <v-list-tile-title>{{ item.name ? item.name : item }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-radio-group>
    <v-layout row wrap class="px-4" v-if="error">
      <div class="v-text-field__details form-total-error">
        <div class="v-messages theme--light error--text">
          <div class="v-messages__wrapper">
            <div class="v-messages__message" >{{ error[0] }}</div>
          </div>
        </div>
      </div>
    </v-layout>
  </v-list>
</template>

<script>
export default {
  name: 'PosSelectList',
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {
    items: { type: Array, default: () => ([]) },
    radio: { type: Boolean, default: false },
    value: null,
    name: { type: String, default: null },
    error: { type: Array, default: () => ([]) },
  },
  methods: {
    update($event, item) {
      if(this.radio) {
        this.$emit('input', item.id);
      } else {
        if($event) {
          if(this.value.indexOf(item.id ? item.id : item) == -1) {
            this.value.push(item.id ? item.id : item);
          }
        } else {
          const index = this.value.indexOf(item.id ? item.id : item);
          if(index != -1) {
            this.value.splice(index, 1);
          }
        }
        this.$emit('input', this.value);
      }
      
    },
  }
};
</script>
